<template>
  <div>
    <AlertLayout title="Reminders!" message="This module handles blood unit requisitions from facilities"
      type="warning" />
    <div class="flex items-center justify-between gap-4 pb-4 py-1">
      <!-- Left: Filters and Search -->
      <div class="flex items-center gap-4">
        <!-- Filters Dropdown -->
        <div class="relative">
          <button id="dropdownRadioButton"
            class="inline-flex items-center text-gray-400 bg-white border border-gray-300 rounded-md px-6 py-2"
            type="button" @click="toggleDropdown">
            <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z" />
            </svg>
            Filters
            <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 4 4 4-4" />
            </svg>
          </button>
          <div v-show="isDropdownOpen"
            class="absolute z-10 mt-2 w-80 p-4 bg-white border border-gray-300 rounded-lg shadow-lg">
            <div class="flex">
              <button type="button"
                class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                @click="closeDropdown" aria-label="Close">
                <span class="sr-only">Dismiss</span>
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 14 14">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
              </button>
            </div>
            <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
              <!-- Filters for all tabs -->
              <div v-if="currentTab === 'issue-outs' || flag === 'donors' || flag === 'blood-units'" class="mb-4">
                <label for="bloodGroup" class="block mb-2 text-sm font-medium text-gray-900">
                  Blood Group
                </label>
                <select v-model="filters.blood_group_id"
                  class="bg-gray-50 border border-gray-200 text-gray-900 rounded-md block w-full py-2 px-1 dark:placeholder-gray-400">
                  <option :value="null" disabled selected>Select blood group</option>
                  <option v-for="group in bloodGroups" :key="group.blood_group_id" :value="group.blood_group_id">
                    {{ group.description }}
                  </option>
                </select>
              </div>
              <div v-if="flag === 'donors'" class="mb-4">
                <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">
                  Gender
                </label>
                <select id="statusFilter" v-model="filters.gender"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                  <option value="" disabled selected>Select</option>
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div v-if="currentTab === 'issue-outs' || flag === 'blood-units'" class="mb-4">
                <label for="unitProduct" class="block mb-2 text-sm font-medium text-gray-900">
                  Unit Product
                </label>
                <select v-model="filters.unit_product_id"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                  <option :value="null" disabled selected>Select unit product</option>
                  <option v-for="product in unit_products" :key="product.unit_product_id"
                    :value="product.unit_product_id">
                    {{ product.name }}
                  </option>
                </select>
              </div>
              <div v-if="currentTab == 'facility-requests' || currentTab == 'Initiate-request'" class="mb-4">
                <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">
                  Status
                </label>
                <select id="statusFilter" v-model="filters.status"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                  <option value="" disabled selected>Select</option>
                  <option value="Completed">Completed</option>
                  <option value="Partially Issued">Partially Issued</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              <div v-if="currentTab === 'issue-outs'" class="mb-4">
                <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">
                  Status
                </label>
                <select id="statusFilter" v-model="filters.status"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                  <option value="" disabled selected>Select</option>
                  <option value="Issued">Issued</option>
                  <option value="Transfused">Transfused</option>
                  <option value="Transfused With Reaction">Transfused With Reaction</option>
                  <option value="Disposed">Disposed</option>
                  <option value="Expired">Expired</option>
                </select>
              </div>
              <div v-if="flag === 'donors' || flag === 'blood-units'" class="mb-4">
                <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">
                  Facility
                </label>
                <select id="facility_id"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="filters.facility_id">
                  <option value="" disabled selected>
                    Select Facility
                  </option>
                  <option v-for="facility in filteredFacilities" :key="facility.facility_id"
                    :value="facility.facility_id">
                    {{ facility.name }}
                  </option>
                </select>
              </div>
              <div v-if="flag === 'donors'" class="mb-4">
                <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">
                  County
                </label>
                <select id="county_id"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="filters.county_id">
                  <option value="" disabled>Select county</option>
                  <option v-for="county in counties" :key="county.county_id" :value="county.county_id">
                    {{ county.name }}
                  </option>
                </select>
              </div>
              <div class="mb-4">
                <label for="dateFrom" class="block mb-2 text-sm font-medium text-gray-900">
                  Date From
                </label>
                <input type="date" v-model="filters.start_date" id="dateFrom"
                  class="px-4 py-2 w-full text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                  placeholder="Date Range" />
              </div>
              <div class="mb-4">
                <label for="dateTo" class="block mb-2 text-sm font-medium text-gray-900">
                  Date To
                </label>
                <input type="date" v-model="filters.end_date" id="dateTo"
                  class="px-4 py-2 w-full text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                  placeholder="Date Range" />
              </div>
              <div class="flex justify-end space-x-2">
                <button type="button" @click="cancelFilters"
                  class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                  Cancel
                </button>
                <button type="submit"
                  class="px-4 py-2 text-sm font-medium text-white bg-custom-yellow rounded-lg hover:bg-custom-yellow-dark">
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
        <!-- Search Bar -->
        <div class="relative flex">
          <input type="text" v-model="searchQuery" id="table-search"
            class="px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
            placeholder="Search" />
          <button type="submit" class="bg-custom-yellow text-white rounded-r px-2 md:px-3 py-0 md:py-1">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Right: Initiate Request Button -->
      <div v-if="currentTab === 'Initiate-request'" class="flex items-center">
        <CustomButton label="Initiate Request" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
          @click="openInitiateRequestForm" />
      </div>
      <div v-if="currentTab === 'issue-outs'" class="flex items-center">
        <CustomButton label="Print Issued Units" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
          @click="printIssueout" />
      </div>
      <div v-if="currentTab === 'ecosystem-reports'" class="flex items-center">
        <CustomButton label="Print Report" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
          @click="printEcosystemReport" />
      </div>
    </div>

    <!-- Stats Cards -->
    <div v-if="facility_code === 'KTTA'" class="grid grid-cols-1 md:grid-cols-5 gap-6 mb-6">
      <div class="py-2 px-6 rounded shadow-lg cursor-pointer" :class="{ 'bg-orange-200 text-white': flag === 'donors' }"
        @click="showEcosystemReports('donors')">
        <h3 class="text-gray-500 font-medium mb-1">Total Blood Donor</h3>
        <p class="text-3xl font-bold">{{ ecosystem_tally.total_donors || 0 }}</p>
      </div>
      <div class="py-2 px-6 rounded shadow-lg cursor-pointer"
        :class="{ 'bg-orange-200 text-white': flag === 'blood-units' }" @click="showEcosystemReports('blood-units')">
        <h3 class="text-gray-500 font-medium mb-1">Total Blood Units</h3>
        <p class="text-3xl font-bold">{{ ecosystem_tally.total_blood_units || 0 }}</p>
      </div>
      <div class="bg-orange-50 py-2 px-6 rounded shadow-lg">
        <h3 class="text-gray-500 font-medium mb-1">
          Total Quantity Requested
        </h3>
        <p class="text-3xl font-bold">
          {{ ecosystem_tally.total_requested || 0 }}
        </p>
      </div>
      <div class="bg-orange-50 py-2 px-6 rounded shadow-lg">
        <h3 class="text-gray-500 font-medium mb-1">
          Total Quantity Issued
        </h3>
        <p class="text-3xl font-bold">
          {{ ecosystem_tally.total_issued || 0 }}
        </p>
      </div>
      <div class="bg-orange-50 py-2 px-6 rounded shadow-lg">
        <h3 class="text-gray-500 font-medium mb-1">
          Pending Issuance Quantity
        </h3>
        <p class="text-3xl font-bold">
          {{ (ecosystem_tally.total_requested - ecosystem_tally.total_issued) || 0 }}
        </p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs flex border-b mb-4">
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'facility-requests' }"
        @click="currentTab = 'facility-requests'">
        Facility Request
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'issue-outs' }" @click="currentTab = 'issue-outs'">
        Issue Out Listing
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'Initiate-request' }" @click="currentTab = 'Initiate-request'">
        Initiate Request
      </button>
      <button v-if="facility_code === 'KTTA'" class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'ecosystem-reports' }"
        @click="currentTab = 'ecosystem-reports'">
        Ecosystem Reports
      </button>
    </div>
    <div v-if="isPageLoading" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10">
      <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"></div>
    </div>
    <div v-if="showInitiateRequestForm"
      class="fixed inset-0 bg-gray-800 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div class="bg-white p-8 rounded-lg shadow-xl w-1/2">
        <h2 class="text-xl text-gray-600 font-bold mb-4">Request Form</h2>
        <form>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-8">
            <div>
              <label class="block mb-2 text-gray-700 font-medium" for="facility_category">
                Select Facility Category
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select id="facility_category"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="formData.facility_category">
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="Government"> Government </option>
                  <option value="Neighbouring Hospitals"> Neighbouring Hospitals </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label class="block mb-2 text-gray-700 font-medium" for="facility">
                Select Facility
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select id="facility_id"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="formData.facility_id" :disabled="!formData.facility_category">
                  <option value="" disabled selected>
                    Select Facility
                  </option>
                  <option v-for="facility in filteredFacilities" :key="facility.facility_id"
                    :value="facility.facility_id">
                    {{ facility.name }}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="my-2">
              <label class="block mb-1 text-gray-700" for="productRequired">
                Date Required
                <span class="text-red-500">*</span>
              </label>
              <input type="date" id="productRequired"
                class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                v-model="formData.date_required" />
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block mb-2 text-gray-700 font-medium" for="blood_group">
                Select blood group
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select id="blood_group_id"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="formData.blood_group_id" required>
                  <option value="" disabled>Select blood group</option>
                  <option v-for="group in bloodGroups" :key="group.blood_group_id" :value="group.blood_group_id">
                    {{ group.description }}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label class="block mb-2 text-gray-700 font-medium" for="blood_group">
                Select product
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select id="unit_product"
                  class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="formData.unit_product_id">
                  <option value="" disabled selected>
                    Select product
                  </option>
                  <option v-for="unit in unit_products" :key="unit.unit_product_id" :value="unit.unit_product_id">
                    {{ unit.description }}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label class="block mb-1 text-gray-700" for="product">
                Required Quantity
                <span class="text-red-500">*</span>
              </label>
              <input id="product" type="number"
                class="w-full px-3 py-2 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                placeholder="Enter Quantity" v-model="formData.requested_quantity" />
            </div>
            <div class="flex justify-end">
              <button type="button" class="py-1 px-3 h-10 mt-8 border rounded text-white bg-custom-yellow"
                @click="addProduct">
                <svg class="w-6 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="20"
                  fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M5 12h14m-7 7V5" />
                </svg>
              </button>
            </div>
          </div>
          <table class="w-full text-left rtl:text-right mt-10 text-gray-700 border-b border-gray-400">
            <thead>
              <tr class="bg-gray-100">
                <th scope="col" class="px-6 py-2">
                  <div class="flex items-center">
                    Blood Group
                  </div>
                </th>
                <th scope="col" class="px-6 py-2">
                  <div class="flex items-center">
                    Blood Product
                  </div>
                </th>
                <th scope="col" class="px-6 py-2">
                  <div class="flex items-center">
                    Quantity
                  </div>
                </th>
                <th scope="col" class="px-6 py-2">
                  <div class="flex items-center"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b" v-for="(product, index) in products" :key="index">
                <td class="px-4 py-2">
                  {{ getBloodGroupName(product.blood_group_id) }}
                </td>
                <td class="px-4 py-2">
                  {{ getProductName(product.unit_product_id) }}
                </td>
                <td class="px-4 py-2">
                  {{ product.requested_quantity }}
                </td>
                <td class="pl-4 py-2">
                  <div class="flex justify-end">
                    <button type="button" class="px-2 py-1 dark:text-white bg-custom-yellow rounded"
                      @click="editProduct(index)">
                      <svg class="w-4 h-4 dark:text-white bg-custom-yellow" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z" />
                      </svg>
                    </button>
                    <button type="button" class="px-2 py-1 ml-3 dark:text-white bg-red-500 rounded"
                      @click="deleteProduct(index)">
                      <svg class="w-4 h-4 dark:text-white bg-red-500" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="flex justify-between mt-5 space-x-2">
            <button type="button" @click="closeProductPopup" class="px-4 py-1 bg-gray-200 text-gray-800 rounded">
              Close
            </button>
            <button type="button" class="px-4 py-2 text-white rounded bg-custom-yellow" @click="submitRequest"
              :disabled="products.length === 0">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <component :is="currentTabComponent" :flag="flag" :search-query="searchQuery" :filters="filters"
      @cancel-filters="cancelFilters" ref="currentTabComponent"></component>
  </div>
</template>

<script>
import AlertLayout from "@/components/AlertLayout.vue";
import api from '@/services/api';
import CustomButton from "@/components/CustomButton.vue";
import FacilityRequestTab from "../tabs/FacilityRequestTab.vue";
import IssuedRequestTab from "../tabs/IssuedRequestTab.vue";
import InitialRequestTab from "../tabs/InitialRequestTab.vue";
import SweetAlertService from '@/services/SweetAlertService';
import EcosystemReportsTab from "../tabs/EcosystemReportsTab.vue";

export default {
  name: "EcosystemPage",
  components: {
    AlertLayout,
    CustomButton,
    FacilityRequestTab,
    IssuedRequestTab,
    InitialRequestTab,
    EcosystemReportsTab
  },
  data() {
    return {
      flag: "",
      searchQuery: "",
      isPageLoading: false,
      loading: false,
      isDropdownOpen: false,
      userData: null,
      facility_code: null,
      facility_logo: null,
      currentTab: null,
      showInitiateRequestForm: false,
      bloodGroups: [],
      unit_products: [],
      issuedUnits: [],
      products: [],
      facilities: [],
      counties: [],
      facility_data: '',
      editingIndex: null,
      selectedRequisitionId: null,
      ecosystem_tally: {
        total_donors: 0,
        total_blood_units: 0,
        total_requested: 0,
        total_issued: 0
      },
      formData: {
        blood_group_id: "",
        unit_product_id: "",
        requested_quantity: "",
        unit_product_ids: [],
        date_required: "",
        facility_category: "",
        facility_id: ""
      },
      filters: {
        blood_group_id: "",
        status: "",
        unit_product_id: "",
        start_date: "",
        end_date: "",
        facility_id: "",
        gender: "",
        county_id: ""
      },
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "facility-requests":
          return "FacilityRequestTab";
        case "issue-outs":
          return "IssuedRequestTab";
        case "Initiate-request":
          return "InitialRequestTab";
        case "ecosystem-reports":
          return "EcosystemReportsTab";
        default:
          return "FacilityRequestTab";
      }
    },
    filteredFacilities() {
      const search = this.searchQuery.toLowerCase();
      let filtered = this.facilities;

      // Filter based on facility_category
      if (this.formData.facility_category === "Government") {
        filtered = this.facilities.filter(facility => facility.facility_code === "KTTA" && facility.facility_id != this.facility_data.facility_id);
      } else if (this.formData.facility_category === "Neighbouring Hospitals") {
        filtered = this.facilities.filter(facility => facility.facility_code !== "KTTA" && facility.facility_id != this.facility_data.facility_id);
      } else {
        filtered = this.facilities.filter(facility => facility.facility_id != this.facility_data.facility_id);
      }
      // Apply search filter
      return filtered.filter((facility) => {
        const safeToLower = (value) =>
          typeof value === "string" ? value.toLowerCase() : "";

        return (
          safeToLower(facility.name)?.includes(search) ||
          safeToLower(facility.email)?.includes(search) ||
          safeToLower(facility.contact_person_name)?.includes(search) ||
          safeToLower(facility.contact_person_phone)?.includes(search) ||
          safeToLower(facility.county?.name)?.includes(search) ||
          safeToLower(facility.longitude)?.includes(search) ||
          safeToLower(facility.latitude)?.includes(search) ||
          safeToLower(facility.account_status)?.includes(search) ||
          safeToLower(facility.created_at)?.includes(search)
        );
      });
    },
  },
  created() {
    // Restore the currentTab from localStorage if it exists
    const savedTab = localStorage.getItem('ecosystemPageTab');
    if (savedTab && [
      'facility-requests',
      'issue-outs',
      'Initiate-request',
      'ecosystem-reports'
    ].includes(savedTab)) {
      this.currentTab = savedTab;
    }
    this.userData = this.$store.getters["auth/user"];
    this.facility_data = this.userData?.user_roles[0]?.facility_department?.facility
    this.facility_code = this.facility_data?.facility_code || '';
    this.facility_logo = this.userData?.user_roles[0]?.facility_department?.facility?.logo;
    this.currentTab = "facility-requests";
    this.fetchBloodGroups();
    this.fetchProductsData();
    this.getEcosystemTally();
    this.fetchFacilities();
    this.fetchRegions();
    this.getEcosystemIssuedUnit();
  },
  watch: {
    // Watch for changes to currentTab and save to localStorage
    currentTab(newTab) {
      localStorage.setItem('ecosystemPageTab', newTab);
      if (newTab === 'ecosystem-reports') {
        this.flag = 'donors';
      } else {
        this.flag = '';
      }
    }
  },
  methods: {
    showEcosystemReports(flagType) {
      if (this.currentTab !== 'ecosystem-reports') {
        this.currentTab = 'ecosystem-reports';
      }
      this.flag = flagType;
    },
    async fetchFacilities() {
      this.loading = true
      try {
        const response = await api.getFacilities();
        this.facilities = response.data || response;
      } catch (error) {
        this.error = error.message || "Failed to fetch facilities";
      } finally {
        this.loading = false
      }
    },
    async getEcosystemTally() {
      try {
        this.ecosystem_tally = await api.getEcosystemRequestsTally();
      } catch (error) {
        console.error('API Error:', error.response || error.message);
        this.error = error.response?.data?.errors || error.message || "Failed to fetch requisition details";
      }
    },
    async fetchRegions() {
      try {
        const response = await api.getRegions();
        const kenyaRegion = response.regions.find((region) => region.name === 'Kenya');
        this.counties = kenyaRegion ? kenyaRegion.counties : [];
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    },
    openInitiateRequestForm() {
      this.showInitiateRequestForm = true;
    },
    closeProductPopup() {
      this.showInitiateRequestForm = false;
      this.formData = {
        blood_group_id: "",
        unit_product_id: "",
        requested_quantity: "",
        date_required: "",
      };
      this.products = [];
      this.editingIndex = null;
    },
    async submitRequest() {
      try {
        const payload = {
          products: this.products,
          date_required: this.formData.date_required,
          facility_id: this.formData.facility_id
        };

        await api.createEcosystemBloodRequest(payload);
        await SweetAlertService.showSuccess('Success!', 'Request saved successfully!');
        this.products = [];
        this.formData.date_required = "";
        this.showInitiateRequestForm = false;
        this.$router.go(0);
      } catch (error) {
        this.error = error.message || 'Failed to save request';
        console.error('Error submitting the form:', error);
        SweetAlertService.showError('Error', 'Error saving request.');
      }
    },
    async fetchBloodGroups() {
      try {
        const response = await api.getBloodGroups();
        this.bloodGroups = response;
      } catch (error) {
        console.error('Error fetching blood groups:', error);
      }
    },
    async fetchProductsData() {
      try {
        const response = await api.getUnitProducts();
        this.unit_products = response;
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    },
    getBloodGroupName(blood_group_id) {
      const blood_group = this.bloodGroups.find((bg) => bg.blood_group_id === blood_group_id);
      return blood_group ? blood_group.description : 'Unknown blood group';
    },
    getProductName(unit_product_id) {
      const product = this.unit_products.find((unit) => unit.unit_product_id === unit_product_id);
      return product ? product.description : 'Unknown Product';
    },
    addProduct() {
      if (this.formData.unit_product_id && this.formData.blood_group_id && this.formData.requested_quantity) {
        if (this.editingIndex !== null) {
          this.updateProduct();
        } else {
          this.products.push({
            blood_group_id: this.formData.blood_group_id,
            unit_product_id: this.formData.unit_product_id,
            requested_quantity: this.formData.requested_quantity,
          });
        }
        this.formData.blood_group_id = "";
        this.formData.unit_product_id = "";
        this.formData.requested_quantity = "";
        this.editingIndex = null;
      } else {
        SweetAlertService.showError('Error', 'Please fill all required fields');
      }
    },
    editProduct(index) {
      const product = this.products[index];
      this.formData.blood_group_id = product.blood_group_id;
      this.formData.unit_product_id = product.unit_product_id;
      this.formData.requested_quantity = product.requested_quantity;
      this.editingIndex = index;
    },
    updateProduct() {
      if (this.editingIndex !== null) {
        this.products[this.editingIndex].blood_group_id = this.formData.blood_group_id;
        this.products[this.editingIndex].unit_product_id = this.formData.unit_product_id;
        this.products[this.editingIndex].requested_quantity = this.formData.requested_quantity;
        this.editingIndex = null;
      }
    },
    deleteProduct(index) {
      this.products.splice(index, 1);
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    applyFilters() {
      console.log('Applying filters:', this.filters);
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },
    applyFiltersToCurrentTab() {
      if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.applyFilters === 'function') {
        this.$refs.currentTabComponent.applyFilters(this.filters);
      } else {
        console.warn('applyFilters method not found on current tab component');
      }
    },
    cancelFilters() {
      this.filters = {
        blood_group_id: null,
        status: null,
        unit_product_id: null,
        start_date: null,
        end_date: null,
        facility_id: null,
        gender: null,
        county_id: null
      };
      this.searchQuery = "";
      console.log('Filters cleared:', this.filters);
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    async getEcosystemIssuedUnit() {
      this.loading = true;
      try {
        const queryParams = {
          blood_group_id: this.filters.blood_group_id,
          status: this.filters.status,
          unit_product_id: this.filters.unit_product_id,
          start_date: this.filters.start_date,
          end_date: this.filters.end_date,
          search_query: this.localSearchQuery,
          page: this.currentPage,
          per_page: this.perPage,
          all: true
        };

        const response = await api.fetchIssuedLogs(queryParams);
        this.issuedUnits = response.data || [];
        this.currentPage = response.current_page || 1;
        this.totalPages = response.total_pages || 1;
        this.totalCount = response.total_count || 0;
      } catch (error) {
        this.error = error.response?.data?.errors || error.message || "Failed to fetch issued logs";
        await SweetAlertService.showError('Error', this.error);
      } finally {
        this.loading = false;
      }
    },
    printIssueout() {
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      printWindow.style.border = 'none';
      document.body.appendChild(printWindow);

      try {
        const printContent = `
              <div class="page-container">
                <div class="report-container">
                  <div class="logo-container">
                    <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
                  </div>
                  <h1 class="text-lg font-bold mb-4">Blood Request Issueouts</h1>
                  <div class="section">
                    <div class="section-title">Units Issued</div>
                    <div class="table-container">
                      <table class="w-full">
                        <thead>
                          <tr>
                            <th>Serial No.</th>
                            <th>Blood Group</th>
                            <th>Unit Product</th>
                            <th>Issuing Facility</th>
                            <th>Requesting Facility</th>
                            <th>Issue Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${this.issuedUnits
            .map(
              (unit, index) => `
                                <tr${index % 2 === 0 ? ' class="bg-gray-50"' : ''}>
                                  <td>${unit.product?.pint_serial || 'N/A'}</td>
                                  <td>${unit.product?.blood_group?.description}</td>
                                  <td>${unit.product?.unit_product.description}</td>
                                  <td>${unit.facility_issuing?.name}</td>
                                  <td>${unit.facility_issued_to?.name}</td>
                                  <td>${unit.issue_date}</td>
                                  <td>${unit.status}</td>
                                </tr>
                              `
            )
            .join('')}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            `;

        const printDocument = `
              <html>
              <head>
                <title>Blood Request Details</title>
                <style>
                  @media print {
                    @page {
                      size: A4;
                      margin: 2cm;
                    }
                  }
                  body {
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                    color: #333;
                    margin: 0;
                    padding: 0;
                  }
                  .page-container {
                    padding: 20px;
                  }
                  .logo-container {
                    text-align: center;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    margin-bottom: 15px;
                  }
                  .logo {
                    width: 120px;
                    align-items: center;
                  }
                  .report-container {
                    max-width: 100%;
                    margin: 0 auto;
                  }
                  h1 {
                    text-align: center;
                    font-size: 24px;
                    margin-bottom: 5px;
                  }
                  .section {
                    margin-bottom: 30px;
                  }
                  .section-title {
                    font-size: 18px;
                    font-weight: bold;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 8px;
                    margin-bottom: 15px;
                  }
                  .grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                  }
                  .info-row {
                    margin-bottom: 8px;
                  }
                  .info-label {
                    font-weight: bold;
                  }
                  .table-container {
                    width: 100%;
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 15px;
                    font-size: 12px;
                  }
                  th, td {
                    border: 1px solid #ddd;
                    padding: 8px 12px;
                    text-align: left;
                  }
                  th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                  }
                  .bg-gray-50 {
                    background-color: #f9f9f9;
                  }
                  @media print {
                    body {
                      print-color-adjust: exact;
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
                ${printContent}
              </body>
              </html>
            `;

        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(printWindow);
          }, 1000);
        };
      } catch (error) {
        console.error('Error generating print content:', error);
        document.body.removeChild(printWindow);
      }
    },
    async printEcosystemReport() {
      if (this.flag === 'donors') {
        const queryParams = {
          ...this.filters,
          search_query: this.searchQuery,
          all: true
        };
        const response = await api.getEcosystemDonors(queryParams);
        this.donors = response.data || response;
        this.printEcosystemDonorReport(this.donors);
      } else if (this.flag === 'blood-units') {
        const queryParams = {
          ...this.filters,
          search_query: this.searchQuery,
          all: true
        };
        const response = await api.fetchEcosystemFilteredProducts(queryParams);
        this.products = response.data || response;
        this.printEcosystemUnitReport(this.products);
      } else {
        console.error('Invalid flag for printing');
        return;
      }
    },

    printEcosystemDonorReport(donors) {
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      printWindow.style.border = 'none';
      document.body.appendChild(printWindow);

      try {
        const printContent = `
              <div class="page-container">
                <div class="report-container">
                  <div class="logo-container">
                    <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
                  </div>
                  <h1 class="text-lg font-bold mb-4">Blood Donors</h1>
                  <div class="section">
                    <div class="table-container">
                      <table class="w-full">
                        <thead>
                          <tr>
                            <th>Donor Names</th>
                            <th>Blood Group</th>
                            <th>Gender</th>
                            <th>Facility</th>
                            <th>Residence</th>
                            <th>Date Registered</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${donors
            .map(
              (donor, index) => `
                                <tr${index % 2 === 0 ? ' class="bg-gray-50"' : ''}>
                                  <td>${donor.user.first_name} ${donor.user?.last_name}</td>
                                  <td>${donor.user?.blood_group_id?.description ?? "Unknown"}</td>
                                  <td>${donor.user?.gender ?? "Unknown"}</td>
                                  <td>${donor.blood_donations[0]?.facility_id?.name ?? ""}</td>
                                  <td>${donor.county_id?.name ?? "Unknown"}</td>
                                  <td>${new Date(donor.created_at).toLocaleDateString("en-CA")}</td>
                                </tr>
                              `
            )
            .join('')}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            `;

        const printDocument = `
              <html>
              <head>
                <title>Blood Request Details</title>
                <style>
                  @media print {
                    @page {
                      size: A4;
                      margin: 2cm;
                    }
                  }
                  body {
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                    color: #333;
                    margin: 0;
                    padding: 0;
                  }
                  .page-container {
                    padding: 20px;
                  }
                  .logo-container {
                    text-align: center;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    margin-bottom: 15px;
                  }
                  .logo {
                    width: 120px;
                    align-items: center;
                  }
                  .report-container {
                    max-width: 100%;
                    margin: 0 auto;
                  }
                  h1 {
                    text-align: center;
                    font-size: 24px;
                    margin-bottom: 5px;
                  }
                  .section {
                    margin-bottom: 30px;
                  }
                  .section-title {
                    font-size: 18px;
                    font-weight: bold;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 8px;
                    margin-bottom: 15px;
                  }
                  .grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                  }
                  .info-row {
                    margin-bottom: 8px;
                  }
                  .info-label {
                    font-weight: bold;
                  }
                  .table-container {
                    width: 100%;
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 15px;
                    font-size: 12px;
                  }
                  th, td {
                    border: 1px solid #ddd;
                    padding: 8px 12px;
                    text-align: left;
                  }
                  th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                  }
                  .bg-gray-50 {
                    background-color: #f9f9f9;
                  }
                  @media print {
                    body {
                      print-color-adjust: exact;
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
                ${printContent}
              </body>
              </html>
            `;

        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(printWindow);
          }, 1000);
        };
      } catch (error) {
        console.error('Error generating print content:', error);
        document.body.removeChild(printWindow);
      }
    },
    printEcosystemUnitReport(units) {
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      printWindow.style.border = 'none';
      document.body.appendChild(printWindow);

      try {
        const printContent = `
              <div class="page-container">
                <div class="report-container">
                  <div class="logo-container">
                    <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
                  </div>
                  <h1 class="text-lg font-bold mb-4">Blood Units</h1>
                  <div class="section">
                    <div class="table-container">
                      <table class="w-full">
                        <thead>
                          <tr>
                            <th>Serial no.</th>
                            <th>Blood Product</th>
                            <th>Blood Group</th>
                            <th>Facility</th>
                            <th>Donation Date</th>
                            <th>Expiry Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${units
            .map(
              (product, index) => `
                                <tr${index % 2 === 0 ? ' class="bg-gray-50"' : ''}>
                                  <td>${product.pint_serial}</td>
                                  <td>${product.unit_product?.description}</td>
                                  <td>${product.blood_group?.description}</td>
                                  <td>${product.facility?.name}</td>
                                  <td>${product.blood_donation?.date_added ? new Date(product.blood_donation?.date_added).toLocaleString() : new Date(product.created_at).toLocaleString()}</td>
                                  <td>${new Date(product.expiry_date).toLocaleString() ?? 'N/A'}</td>
                                </tr>
                              `
            )
            .join('')}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            `;

        const printDocument = `
              <html>
              <head>
                <title>Blood Request Details</title>
                <style>
                  @media print {
                    @page {
                      size: A4;
                      margin: 2cm;
                    }
                  }
                  body {
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                    color: #333;
                    margin: 0;
                    padding: 0;
                  }
                  .page-container {
                    padding: 20px;
                  }
                  .logo-container {
                    text-align: center;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    margin-bottom: 15px;
                  }
                  .logo {
                    width: 120px;
                    align-items: center;
                  }
                  .report-container {
                    max-width: 100%;
                    margin: 0 auto;
                  }
                  h1 {
                    text-align: center;
                    font-size: 24px;
                    margin-bottom: 5px;
                  }
                  .section {
                    margin-bottom: 30px;
                  }
                  .section-title {
                    font-size: 18px;
                    font-weight: bold;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 8px;
                    margin-bottom: 15px;
                  }
                  .grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                  }
                  .info-row {
                    margin-bottom: 8px;
                  }
                  .info-label {
                    font-weight: bold;
                  }
                  .table-container {
                    width: 100%;
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 15px;
                    font-size: 12px;
                  }
                  th, td {
                    border: 1px solid #ddd;
                    padding: 8px 12px;
                    text-align: left;
                  }
                  th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                  }
                  .bg-gray-50 {
                    background-color: #f9f9f9;
                  }
                  @media print {
                    body {
                      print-color-adjust: exact;
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
                ${printContent}
              </body>
              </html>
            `;

        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(printWindow);
          }, 1000);
        };
      } catch (error) {
        console.error('Error generating print content:', error);
        document.body.removeChild(printWindow);
      }
    },
  },
  mounted() {
    const facilityId = this.user().facility_id;
    console.log('facility_id:', facilityId);
  }
};
</script>

<style lang="css" scoped></style>